import React from 'react'; 

const HeadingFour = ({ children }) => {
  return (
    <h4 className="
      font-semibold 
      sm:text-lg 
      md:text-xl 
      "
    >
      {children}
    </h4>
  );
};

export default HeadingFour;
